/* import __COLOCATED_TEMPLATE__ from './boot-error.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();